<template>
  <div class="content">
    <div class="flex fdc aic jcc">
      <i class="iconfont icon-systemmaintenance "></i>
      <div class="f30">设备升级中,敬请期待...</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
html,
body,
.content {
  width: 100% !important;
  height: 100% !important;
  background-image: url("https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201708%2F08%2F20170808104131_i4TJ3.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1695542216&t=e784e5ef05605cf590074e0e8c85c58d");
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.iconfont {
  color: #0891ff;
  font-size: 500px;
}
</style>
